import { SlideUpLine, FadeUp, Stagger, StaggerItem } from "@/pages/_shared/anim";
import ElevatorMachine from "../../../assets/Home9.jpg";

const reasons = [
  {
    icon: "ri-stack-line",
    title: "Multi-Brand Technical Requirements",
    desc: "Support across multiple elevator and escalator brands without being tied to a single manufacturer.",
  },
  {
    icon: "ri-search-line",
    title: "Hard-to-Find Spare Parts",
    desc: "Access to a comprehensive range of electrical, electronic, mechanical, and control components.",
  },
  {
    icon: "ri-cpu-line",
    title: "PCB Repair Requirements",
    desc: "All-brand repair support for single-layer, double-layer, and multilayer PCBs.",
  },
  {
    icon: "ri-tools-line",
    title: "Technical Troubleshooting",
    desc: "Professional diagnosis and technical assistance for elevator and escalator systems.",
  },
  {
    icon: "ri-lightbulb-line",
    title: "Alternative Elevator Solutions",
    desc: "Alternative design ideas and technical solutions with or without machine rooms.",
  },
  {
    icon: "ri-arrow-up-circle-line",
    title: "Installation & Modernization",
    desc: "Complete elevator supply, installation, maintenance, and upgradation requirements.",
  },
];

export default function Testimonials() {
  return (
    <section className="bg-crest-bg py-20 md:py-28 relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage:
            `url(${ElevatorMachine})`,
          backgroundSize: "cover",
        }}
      />
      <div className="relative px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <FadeUp>
              <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] text-crest-orange uppercase">
                <span className="w-6 h-px bg-crest-orange/60" /> Why customers choose us
              </span>
            </FadeUp>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-white leading-tight mt-5">
              <SlideUpLine as="div">Why Customers</SlideUpLine>
              <SlideUpLine as="div" delay={0.1} className="text-white">
                Come to Uplift One.
              </SlideUpLine>
            </h2>
            <FadeUp delay={0.2}>
              <p className="text-white/75 text-base md:text-lg leading-relaxed mt-6 max-w-md">
                From spare parts and PCB repairs to complete installations — our customers rely on us for practical, technically sound elevator solutions.
              </p>
            </FadeUp>
          </div>

          <div className="lg:col-span-7">
            <FadeUp delay={0.15}>
              <div className="bg-crest-deep/40 backdrop-blur rounded-lg border border-white/10 p-8 md:p-10">
                <Stagger className="grid grid-cols-1 md:grid-cols-2 gap-4" stagger={0.08}>
                  {reasons.map((r) => (
                    <StaggerItem key={r.title}>
                      <div className="flex items-start gap-4 p-4 rounded-lg hover:bg-white/5 transition-colors">
                        <span className="w-10 h-10 flex items-center justify-center rounded-md bg-crest-orange text-white shrink-0">
                          <i className={`${r.icon} text-lg`}></i>
                        </span>
                        <div>
                          <h3 className="text-white font-semibold text-sm">{r.title}</h3>
                          <p className="text-white/65 text-sm mt-1 leading-relaxed">{r.desc}</p>
                        </div>
                      </div>
                    </StaggerItem>
                  ))}
                </Stagger>
              </div>
            </FadeUp>
          </div>
        </div>
      </div>
    </section>
  );
}